import { stringify } from 'qs';
import request from '../utils/request';


export async function getList(params) {
  return request(`/product/product-types?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/product-types/${id}`, { params });
}

export async function create(body) {
  return request(`/product/product-types`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/product-types/${id}`, {
    method: 'POST',
    body,
  });
}

export async function syncOne(params, id, partner_id) {
  return request(`/product/sync-product/product/${id}/partner/${partner_id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}
export async function syncCreateProduct(params) {
  return request(`/product/kiotviet/create-product`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}



export async function checkConnectKiotViet(params) {
  return request(`/product/kiotviet/check-connect`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}
export async function syncKiotViet(params) {
  return request(`/product/kiotviet/sync-product`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}
